import { useTranslation } from '@/app/i18n/client'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from '@/components/ui/dialog'
import Image from 'next/image'
import { useState } from 'react'
interface DeleteDialogProps {
  onConfirm: () => void
  title: string
  message: string
}

const DeleteDialog = ({ onConfirm, title, message }: DeleteDialogProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation()

  const handleConfirm = () => {
    onConfirm()
    setIsOpen(false)
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Image
          width={16}
          height={14.8}
          src="/assets/Icons/Delete.svg"
          alt="Delete"
          className="bg-[#fff] cursor-pointer hover:bg-[#fff]"
          onClick={() => setIsOpen(true)}
        />
      </DialogTrigger>
      <DialogContent
        className="border-0 p-0 !max-w-[582px] bg-[white] max-h-[90vh]"
        onInteractOutside={(e) => {
          e.preventDefault()
        }}
      >
        <DialogHeader>
          <h1 className="bg-[#ebebeb] px-6 py-3 font-ns_bold text-left text-base">
            {t(title)}
          </h1>
        </DialogHeader>
        <div className="overflow-y-scroll max-h-[70vh] flex flex-col items-center">
          <div className="flex flex-col items-center py-9 pt-10 mobile:text-center mobile:p-[25px]">
            <Image
              src="/assets/Icons/WarningIcon.svg"
              alt="Warning"
              width={37.1}
              height={34.4}
            />
            <p className="text-light_black mt-3">
              {t(
                `Are you sure you want to delete this ${message === 'Company Users' ? 'user' : 'item'} from ${message}?`
              )}
            </p>
            <p className="text-light_black">
              {t('This action cannot be undone.')}
            </p>
          </div>
          <div className="flex gap-x-3 pb-9">
            <Button
              variant="secondary"
              size="sx"
              className="!bg-delete_btn_color border-0"
              onClick={handleConfirm}
            >
              {t('CONTINUE')}
            </Button>
            <DialogClose asChild>
              <Button variant="grayBtn" size="sx" className="px-9">
                {t('NO')}
              </Button>
            </DialogClose>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteDialog
